"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListAppleConnectionsResponseSchema = exports.AppleConnectionSchema = exports.ListAppleConnectionsQuerySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.ListAppleConnectionsQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({});
exports.AppleConnectionSchema = (0, core_1.StrictObject)({
    parentOrgRef: ruby_1.AppleProxyRefSchema,
    // THis is deliberately lenient - we want to see what Apple outputs
    organisations: typebox_1.Type.Array((0, core_1.StrictObject)({
        currency: typebox_1.Type.Optional(typebox_1.Type.String()),
        displayName: typebox_1.Type.Optional(typebox_1.Type.String()),
        orgRef: typebox_1.Type.Optional(ruby_1.AppleProxyRefSchema),
        orgName: typebox_1.Type.Optional(typebox_1.Type.String()),
        paymentModel: typebox_1.Type.String(),
        roleNames: typebox_1.Type.Array(typebox_1.Type.String()),
        timezone: typebox_1.Type.Optional(typebox_1.Type.String()), // AppleProxyTimeZoneSchema
    })),
    error: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.ListAppleConnectionsResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AppleConnectionSchema);
